import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { PulseLoader } from 'react-spinners';
import isNil from 'ramda/src/isNil';
import Button from '@components/@core/Button';
import Icon from '@components/@core/Icon';

const LoadingAnimation = ({ size = 18, color = '#376caf', loading = false, text = '', onReset = () => {} }) => {
    useEffect(() => {
        setTimeout(() => {
            const refresh = document.getElementById('refresh');
            if (!isNil(refresh)) refresh.style.display = 'block';
        }, 10000);
    }, []);

    const closeRefresh = () => {
        const refresh = document.getElementById('refresh');
        if (!isNil(refresh)) refresh.style.display = 'none';
    };

    return loading ? (
        <div className="loading-animation">
            <div className="loading-block">
                <PulseLoader className={size} loading color={color} size={size} />
                <span className={size}>{text}</span>
                <div className="card loading-refresh" id="refresh">
                    <span onClick={closeRefresh}>
                        <Icon name="fas fa-xmark close-icon" />
                    </span>
                    <div className="d-flex ai-center mb-3">
                        <Icon name="fas fa-info-circle me-3" color="#f89d1f" />
                        <p className="dsl-b12 mb-0 text-400 pe-3">Taking too long?</p>
                    </div>
                    <Button className="ml-auto" onClick={() => onReset()}>
                        Refresh
                    </Button>
                </div>
            </div>
        </div>
    ) : null;
};

LoadingAnimation.propTypes = {
    name: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    text: PropTypes.string,
    loading: PropTypes.bool,
    onReset: PropTypes.func,
};

export default memo(LoadingAnimation);
